// Centrálne miesto pre V2 feature flagy (build-time konštanty).
// Default OFF — flag zapne Daniel až po freelancer launch (Decision 3).

// Multi-sadzba DPH UI vo formulári Nová faktúra (prepínač platcu + per-riadok
// výber sadzby + rozpis po sadzbách). Default false → user ho nevidí, faktúra
// ostáva neplatca (bit-identické s pôvodným správaním).
export const V2_DPH_PAYER_UI = false;

// ─── `v2:beta` runtime flag — gate pre NEHOTOVÉ V2 featury ────────────────────
// Oddeľuje nasaditeľné JADRO (faktúry/doc-OS/dashboard/sync — vždy viditeľné) od
// dozrievajúcich featúr (advisor/predictions) ktoré sa buildujú v pozadí. V prode
// OFF (jadro čisté), v app2 beta ON. Consumeri OBALIA nehotové UI:
//   import { isBetaEnabled } from '@/v2/featureFlags';
//   if (isBetaEnabled()) { …advisor… }
//
// Zdroj (poradie): localStorage 'v2:beta' EXPLICITNÝ override ('1'=on, '0'=off,
// vyhráva nad buildom — dev/tím to prepne v appke) → build env REACT_APP_V2_BETA
// ('1'=on, nastaví app2 beta build) → default false (prod bezpečný).
// Defenzívne: localStorage/process môžu hodiť (private mode/SSR) → try/catch → false.
export function isBetaEnabled() {
  try {
    const ls = localStorage.getItem('v2:beta');
    if (ls === '1') return true;
    if (ls === '0') return false; // explicitný override VYPNI (vyhráva nad buildom)
  } catch (e) { /* localStorage nedostupný → skús build env */ }
  try {
    if (process.env.REACT_APP_V2_BETA === '1') return true;
    // Dev-mock (app2-test) = app2/beta prostredie → beta moduly viditeľné aj bez
    // ručného localStorage prepínača, nech testovanie ukáže plný app2.
    // BUGFIX 2026-08-06: bare truthy check na string env var — CI (cf-deploy-v2.yml
    // aj cf-deploy.yml aj pr-check.yml) posiela REACT_APP_DEV_MOCK='false' explicitne
    // (neprázdny string), čo je v JS truthy → isBetaEnabled() bol VŽDY true v každom
    // CI builde (app2.todue.sk aj teraz app.todue.sk po cutovri). Správny vzor už
    // existuje v lib/supabase.js:11 (`=== 'true'`) — zjednotené sem.
    if (process.env.REACT_APP_DEV_MOCK === 'true') return true;
  } catch (e) { /* process nedostupný → default */ }
  return false;
}

// Manuálny prepínač (dev / app2 beta) — zapíše localStorage override, vráti nový
// stav. NIKDY nehádže (private mode → no-op → prečíta aktuálny stav).
export function setBeta(on) {
  try { localStorage.setItem('v2:beta', on ? '1' : '0'); } catch (e) { /* no-op */ }
  return isBetaEnabled();
}
